import { Selection, ToolLike } from '@recogito/annotorious/src/tools/Tool';
import { toSVGTarget } from '@recogito/annotorious/src/selectors/EmbeddedSVG';
import { SVG_NAMESPACE } from '@recogito/annotorious/src/util/SVG';
import 'regenerator-runtime/runtime';
import axios from 'axios'
import './index.scss'
import ort from 'onnxruntime-web';
import JSZip from 'jszip'; // 🔥 Neu hinzugefügt für das Entpacken der .npz Datei

const SAM_INPUT_SIZE = 1024;

/**
 * A 'rubberband' selection tool for creating multipolygon drawing by
 * clicking and dragging using SAM 2.
 */
export default class RubberbandSegmentAnythng extends ToolLike  {

  constructor(anchor, g, config, env, viewer) {
    super(g, config, env);
    this.env = env;
    this.cv = window.cv;
    this.viewer = viewer
    this.IMAGENAME = env.image.src.split('/').pop().split('.')[0];
    this.sam2Features = null; // 🔥 Ersetzt das alte this.embeddings Array
    this.model = null
    this.promptPoints = [];
    this.hasStartPoint = false;

    this.handles = []
    this.lastResultTensor = null;     // ONNX output (raw)
    this.currentMaskMat = null;       // letzte Maske (cv.Mat)
    this.accumulatedMaskMat = null;   // gesamtes Ergebnis (cv.Mat)
    this.lastInferencePoint = null;
    this.minInferenceDistance = 10;
    this.pendingRequest = null;
    this.isRunningSegmentation = false;
    this.queuedSegmentationPoints = null;
    this.scale = 1;
    this.mousepos = anchor;

    this.cvReady = null;
    this.previewTimer = null;
    this.lastPreviewPoint = null;
    this.elementGroup = document.createElementNS(SVG_NAMESPACE, 'g');
    this.elementGroup.setAttribute('class', 'a9s-annotation segment-anything');
    this.draggedElement = document.createElementNS(SVG_NAMESPACE, 'g');
    this.draggedElement.setAttribute('class', 'a9s-annotation segment-anything');
    this.maskElement = document.createElementNS(SVG_NAMESPACE, 'g');
    this.maskElement.setAttribute('class', 'a9s-inner');
    this.maskElement.setAttribute('class', 'segment-anything-mask');
    this.elementGroup.appendChild(this.draggedElement)
    this.elementGroup.appendChild(this.maskElement)
    this.foreignObject = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "foreignObject"
    );

    this.foreignObject.setAttribute("x", 0);
    this.foreignObject.setAttribute("y", 0);
    this.foreignObject.setAttribute(
      "width",
      this.env.image.naturalWidth
    );

    this.foreignObject.setAttribute(
      "height",
      this.env.image.naturalHeight
    );

    this.staticCanvas = document.createElement("canvas");
    this.staticCtx = this.staticCanvas.getContext("2d");

    this.previewCanvas = document.createElement("canvas");
    this.previewCtx = this.previewCanvas.getContext("2d");
    [this.staticCanvas, this.previewCanvas].forEach(canvas => {
      canvas.width = this.env.image.naturalWidth;
      canvas.height = this.env.image.naturalHeight;

      canvas.style.position = 'absolute';
      canvas.style.left = '0';
      canvas.style.top = '0';

      canvas.style.width = '100%';
      canvas.style.height = '100%';

      canvas.style.pointerEvents = 'none';
    });
    this.foreignObject.appendChild(this.staticCanvas);
    this.foreignObject.appendChild(this.previewCanvas);

    this.maskElement.appendChild(this.foreignObject);
    this.outer = document.createElementNS(SVG_NAMESPACE, 'path');
    this.outer.setAttribute('class', 'a9s-outer');

    this.inner = document.createElementNS(SVG_NAMESPACE, 'path');
    this.inner.setAttribute('class', 'a9s-inner');
    this.maskElement.appendChild(this.inner);
    this.group = document.createElementNS(SVG_NAMESPACE, 'g');

    this.multipolygon = document.createElementNS(SVG_NAMESPACE, 'g');
    this.multipolygon.setAttribute('class', 'improved-polygon');

    this.multipolygon.appendChild(this.outer);
    this.multipolygon.appendChild(this.inner);

    this.group.style.display = 'none';
    this.group.appendChild(this.multipolygon);
    g.appendChild(this.elementGroup);

    this.onKeyDown = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyDown);

    this.loadEmbedding(this.IMAGENAME);
    this.loadModel()
  }

  onKeyDown(evt) {
    if ((evt.ctrlKey || evt.metaKey) && evt.key.toLowerCase() === 'z') {
      evt.preventDefault();
      this.undo();
      return;
    }

    if (evt.key === 'n') {
      this.startNewMask();
    }
  }

  renderAccumulated(ctx, canvas) {
    const mat = this.accumulatedMaskMat;
    if (!mat) return;

    const width = mat.cols;
    const height = mat.rows;

    if (canvas.width !== width) canvas.width = width;
    if (canvas.height !== height) canvas.height = height;

    const img = ctx.createImageData(width, height);
    const data = mat.data;

    for (let i = 0; i < data.length; i++) {
      if (data[i]) {
        const idx = i * 4;
        img.data[idx + 1] = 255;
        img.data[idx + 3] = 120;
      }
    }
    ctx.putImageData(img, 0, 0);
  }

  mergeIntoAccumulated(mat) {
    const cv = this.cv;
    if (!mat) return;

    if (!this.accumulatedMaskMat) {
      this.accumulatedMaskMat = mat.clone();
      return;
    }

    cv.bitwise_or(
      this.accumulatedMaskMat,
      mat,
      this.accumulatedMaskMat
    );
  }

  startNewMask() {
    if (this.currentMaskMat) {
      this.mergeIntoAccumulated(this.currentMaskMat);
      this.renderAccumulated(this.staticCtx, this.staticCanvas);
    }

    this.promptPoints = [];
    for (let h of this.handles) {
      if (h.parentNode) h.parentNode.removeChild(h);
    }
    this.handles = [];
    this.hasStartPoint = false;
    this.grabbedElement = null;
    this.queuedSegmentationPoints = null;
    this.lastPreviewPoint = null;
    this.pendingRequest = null;

    if (this.currentMaskMat) {
      this.currentMaskMat.delete();
      this.currentMaskMat = null;
    }
    this.lastResultTensor = null;
    this.pendingRequest = null;
    this.lastPreviewPoint = null;

    this.previewCtx.clearRect(
      0, 0,
      this.previewCanvas.width,
      this.previewCanvas.height
    );
  }

  // ===============================
  // 🧠 MASK UTILS (Für SAM 2 angepasst)
  // ===============================

  maskToBinaryMat(output) {
    const height = output.dims[2];
    const width = output.dims[3];
    const data = output.data;

    // SAM 2 gibt i.d.R. [1, 3, 256, 256] zurück. Wir extrahieren die erste Maske (Index 0).
    const binary = new Uint8Array(height * width);

    for (let i = 0; i < binary.length; i++) {
      // SAM 2 gibt rohe Logits zurück. Kriterium für Aktivierung ist > 0.0
      binary[i] = data[i] > 0.0 ? 255 : 0;
    }

    return this.cv.matFromArray(height, width, this.cv.CV_8UC1, binary);
  }

  combineMasks() {
    return this.accumulatedMaskMat ? this.accumulatedMaskMat.clone() : null;
  }

  onMoveCornerHandle = (pos) => {
    let handleIdx = this.handles.indexOf(this.grabbedElement);

    let pointsUpdated = this.promptPoints.map((pt, idx) => {
       if (handleIdx === idx) {
        return {
          x: pos.x,
          y: pos.y,
          clickType: pos.clickType
        }
      } else {
        return pt;
      }
    });
    const handle = this.drawHandle(pos.x, pos.y);
    handle.classList.add("select");
    if (pos.clickType === 0){
      handle.classList.add("remove");
    } else {
      handle.classList.add("add");
    }
    handle.addEventListener('mousedown', this.onGrab(handle));
    handle.addEventListener('mouseup', this.onSelectCorner(handle));
    handle.addEventListener('contextmenu', this.onRemoveCornerHandle(handle));
    this.scaleHandle(handle);

    this.elementGroup.removeChild(this.grabbedElement);
    this.handles[handleIdx] = handle
    this.grabbedElement = handle
    this.elementGroup.appendChild(handle);
    this.promptPoints = pointsUpdated

    this.setPoints(pointsUpdated, true);
  }

  // Skaliert die kleine 256x256 SAM 2 Maske auf die volle Bildgröße hoch
// 🔥 KORREKTUR 3: Schneidet das Padding weg und skaliert dann hoch
upscaleMaskToFullImage(maskMat) {
    const cv = this.cv;
    const imgW = this.env.image.naturalWidth;
    const imgH = this.env.image.naturalHeight;

    const scale = Math.max(imgW, imgH) / 1024;

    const resizedW = Math.round(imgW / scale);
    const resizedH = Math.round(imgH / scale);

    const padX = Math.round((1024 - resizedW) / 2);
    const padY = Math.round((1024 - resizedH) / 2);

    // Bereich ohne Padding ausschneiden
    const roi = maskMat.roi(
      new cv.Rect(
        padX,
        padY,
        resizedW,
        resizedH
      )
    );

    const full = new cv.Mat();
    // 2. Skaliere direkt vom 1024x1024 Tensor-Raum auf die Bildgröße
    // cv.INTER_LINEAR macht die Maske weich und glatt.
    // Wir sagen OpenCV explizit, dass es den gesamten Bereich von 0 bis 1024
    // auf 0 bis imgW/H mappen soll.
    cv.resize(maskMat, full, new cv.Size(imgW, imgH), 0, 0, cv.INTER_LINEAR);
    roi.delete();
    // 3. Binärisieren
    cv.threshold(full, full, 127, 255, cv.THRESH_BINARY);

    return full;
  }
async scheduleSegmentation() {
    if (this.isRunningSegmentation) return;

    const req = this.pendingRequest;
    this.pendingRequest = null;
    if (!req?.jobs?.length) return;

    this.isRunningSegmentation = true;

    try {
      await new Promise(resolve => requestAnimationFrame(resolve));

      for (const job of req.jobs) {
        const { points } = job;
        const result = await this.runLocalSegmentation(points);
        if (this.promptPoints.length === 0 && !this.lastPreviewPoint) {
           return;
        }
        // 1. Maske binär machen
        const mat = this.maskToBinaryMat(result);

        // 2. EXAKT DIESELBE TRANSFORMATION FÜR BEIDE WEGE
        // Wir erzeugen das Vollbild jetzt VOR der Preview-Visualisierung
        const imageMat = this.upscaleMaskToFullImage(mat);

        // Preview: Zeichne das voll-skalierte Bild, nicht das rohe Tensor-Result
        this.renderMatToPreview(imageMat);

        // Finales Polygon: Update des currentMaskMat
        if (this.currentMaskMat) this.currentMaskMat.delete();
        this.currentMaskMat = imageMat; // imageMat wird hier übernommen

        mat.delete();
      }
    } finally {
      this.isRunningSegmentation = false;
      if (this.pendingRequest) this.scheduleSegmentation();
    }
  }

  // NEUE HILFSFUNKTION: Visualisiert das, was das Polygon auch sieht
  renderMatToPreview(mat) {
    const ctx = this.previewCtx;
    const canvas = this.previewCanvas;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const img = ctx.createImageData(mat.cols, mat.rows);
    const data = mat.data; // CV_8UC1

    for (let i = 0; i < data.length; i++) {
        if (data[i] > 127) { // Thresholding von upscaleMaskToFullImage matchen
            const idx = i * 4;
            img.data[idx + 1] = 255; // Grün
            img.data[idx + 3] = 120; // Alpha
        }
    }
    ctx.putImageData(img, 0, 0);
  }

  maskToPolygons(output) {
    const cv = this.cv;
    console.log("dims", output.dims);

    const height = output.dims[2];
    const width = output.dims[3];
    const data = output.data;

    const pixels = width * height;

    for (let c = 0; c < 4; c++) {

      let positive = 0;

      for (let i = 0; i < pixels; i++) {
        if (data[c * pixels + i] > 0) {
          positive++;
        }
      }

      console.log(
        `channel ${c}`,
        positive,
        "/",
        pixels,
        "=",
        (100 * positive / pixels).toFixed(2) + "%"
      );
    }


    const binary = new Uint8Array(height * width);
    for (let i = 0; i < binary.length; i++) {
      binary[i] = data[i] > 0.0 ? 255 : 0;
    }

    const srcSmall = cv.matFromArray(height, width, cv.CV_8UC1, binary);
    const src = new cv.Mat();

    // Vor Konturenfindung auf Vollbild skalieren
    cv.resize(
      srcSmall,
      src,
      new cv.Size(this.env.image.naturalWidth, this.env.image.naturalHeight),
      0,
      0,
      cv.INTER_NEAREST
    );
    srcSmall.delete();

    const contours = new cv.MatVector();
    const hierarchy = new cv.Mat();

    cv.findContours(src, contours, hierarchy, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

    const polygons = [];
    for (let i = 0; i < contours.size(); i++) {
      const contour = contours.get(i);
      const area = cv.contourArea(contour);
      if (area < 20) continue;

      const approx = new cv.Mat();
      cv.approxPolyDP(contour, approx, 2, true);

      const points = [];
      for (let j = 0; j < approx.data32S.length; j += 2) {
        points.push({
          x: approx.data32S[j],
          y: approx.data32S[j + 1]
        });
      }

      polygons.push(points);
      approx.delete();
    }

    src.delete();
    contours.delete();
    hierarchy.delete();

    return polygons;
  }

  polygonsToPath(polygons) {
    return polygons.map(points => {
      if (!points.length) return "";
      let path = `M ${points[0].x},${points[0].y}`;
      for (let i = 1; i < points.length; i++) {
        path += ` L ${points[i].x},${points[i].y}`;
      }
      return path + " Z";
    }).join(" ");
  }

  renderCombinedPreview() {
    const mat = this.combineMasks();
    if (!mat) return;

    const width = mat.cols;
    const height = mat.rows;

    const canvas = this.overlayCanvas;
    const ctx = this.overlayCtx;

    if (canvas.width !== width) canvas.width = width;
    if (canvas.height !== height) canvas.height = height;

    const img = ctx.createImageData(width, height);

    for (let i = 0; i < mat.data.length; i++) {
      if (mat.data[i] > 0) {
        img.data[i * 4 + 1] = 255;
        img.data[i * 4 + 3] = 120;
      }
    }

    ctx.putImageData(img, 0, 0);
    mat.delete();
  }

  finalizePolygon = async () => {
    console.log("finalizePolygon start");
    if (this.currentMaskMat) {
      this.mergeIntoAccumulated(this.currentMaskMat);
      this.renderAccumulated(this.staticCtx, this.staticCanvas);
    }
    const mat = this.accumulatedMaskMat;

    if (!mat) {
      throw new Error("No accumulated mask available");
    }

    const polygons = this.matToPolygons(mat);
    console.log("final polygons:", polygons)
    if (!polygons.length) {
      console.warn("No polygons found");
      return;
    }

    const path = this.polygonsToPath(polygons);
    this.inner.setAttribute("d", path);

    return this.inner;
  }

  matToPolygons(mat) {
    console.log("matToPolygons")
    const cv = this.cv;
    if (!mat || !mat.data) {
      console.warn("Invalid mat");
      return [];
    }
    const contours = new cv.MatVector();
    const hierarchy = new cv.Mat();

    cv.findContours(mat, contours, hierarchy, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

    const polygons = [];
    for (let i = 0; i < contours.size(); i++) {
      const contour = contours.get(i);
      const rect = cv.boundingRect(contour);

      console.log("Contour bbox", {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
      });

      const area = cv.contourArea(contour);
      if (area < 20) continue;

      const approx = new cv.Mat();
      const points = [];
      cv.approxPolyDP(contour, approx, 2, true);
      let minX = Infinity;
      let maxX = -Infinity;
      let minY = Infinity;
      let maxY = -Infinity;

      for (let j = 0; j < approx.data32S.length; j += 2) {
          const x = approx.data32S[j];
          const y = approx.data32S[j + 1];

          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x);
          minY = Math.min(minY, y);
          maxY = Math.max(maxY, y);
      }

      console.log("Approx bbox", {
          width: maxX - minX,
          height: maxY - minY
      });

      for (let j = 0; j < approx.data32S.length; j += 2) {
        points.push({
          x: approx.data32S[j],
          y: approx.data32S[j + 1]
        });
      }

      polygons.push(points);
      approx.delete();
    }

    contours.delete();
    hierarchy.delete();
    console.log("resulting polygons", polygons);
    return polygons;
  }

  // 🔥 Tiling-Hilfsmethoden komplett vereinfacht. Es gibt nur noch einen globalen Job.
  setPoints = async (points, force) => {
    if (!this.sam2Features || !this.model) {
      this.queuedSegmentationPoints = points;
      return;
    }

    if (!points.length) return;

    this.pendingRequest = {
      jobs: [{
        points: points
      }]
    };

    this.scheduleSegmentation();
  }

  flushQueuedSegmentation() {
    if (!this.queuedSegmentationPoints || !this.sam2Features || !this.model)
      return;

    const points = this.queuedSegmentationPoints;
    this.queuedSegmentationPoints = null;

    this.setPoints(points, true);
  }

  // 🔥 SAM 2 Inferenz mit 3 getrennten Feature-Eingängen aus der .npz Datei
async runLocalSegmentation(points) {
    console.log("runLocalSegmentation START");
    await new Promise(requestAnimationFrame);

    const { image_embeddings, high_res_features1, high_res_features2 } = this.sam2Features;
    console.log("image_embeddings", image_embeddings.shape);
    console.log("high_res_features1", high_res_features1.shape);
    console.log("high_res_features2", high_res_features2.shape);

    // 🔥 WICHTIG: Nutze die absolute 2048er Basis, die wir im Export-Skript definiert haben!
    const BASE_SIZE = 1024;

    // Wir normalisieren die Punkte auf den Bereich [0, 1],
    // basierend auf der tatsächlichen Bildgröße des Annotorious-Containers
const imgW = this.env.image.naturalWidth;
    const imgH = this.env.image.naturalHeight;

    // 🔥 NEU: Unabhängige Skalierung für Breite und Höhe
    const scaleX = imgW / 1024;
    const scaleY = imgH / 1024;

    const coords = points.map(pt => [
      pt.x / scaleX,
      pt.y / scaleY
    ]);

    const pointCoordsTensor = new ort.Tensor('float32', new Float32Array(coords.flat()), [1, points.length, 2]);
    const pointLabelsTensor = new ort.Tensor('float32', new Float32Array(points.map(p => p.clickType)), [1, points.length]);
    // 🔥 WICHTIG: Die Maske muss IMMER das 4-fache der Embedding-Größe sein.
    // Wenn image_embeddings.shape[2] 128 ist, muss die Maske 512x512 sein!
    const embedH = image_embeddings.shape[2];
    const embedW = image_embeddings.shape[3];
    const maskSize = embedH * 4;

    const maskInputTensor = new ort.Tensor('float32', new Float32Array(maskSize * maskSize), [1, 1, maskSize, maskSize]);
    const hasMaskInputTensor = new ort.Tensor('float32', new Float32Array([0]), [1]);

    // 🔥 Das Modell erwartet nun die 2048er Größe
    const origImSizeTensor = new ort.Tensor('int64', new BigInt64Array([BigInt(SAM_INPUT_SIZE), BigInt(SAM_INPUT_SIZE)]), [2]);

    const feeds = {
      image_embeddings: new ort.Tensor('float32', image_embeddings.data, image_embeddings.shape),
      high_res_features1: new ort.Tensor('float32', high_res_features1.data, high_res_features1.shape),
      high_res_features2: new ort.Tensor('float32', high_res_features2.data, high_res_features2.shape),
      point_coords: pointCoordsTensor,
      point_labels: pointLabelsTensor,
      mask_input: maskInputTensor,
      has_mask_input: hasMaskInputTensor,
    };
    console.log("before model.run");
    console.log(this.model.inputNames);
    console.log(this.model.outputNames);

    console.log(image_embeddings.shape);
    console.log(high_res_features1.shape);
    console.log(high_res_features2.shape);
    const results = await this.model.run(feeds);
    console.log("after model.run",results.masks);
    return results.masks;
  }

  onRemoveCornerHandle = element => evt => {
    evt.preventDefault();
    if (this.promptPoints.length > 1) {
      this.elementGroup.removeChild(element);
      this.promptPoints = this.promptPoints.filter((pt, idx) => {
        return idx !== this.handles.indexOf(element);
      });
      this.setPoints(this.promptPoints, true);
    }
  }

  scalePoint(pt) {
    return {
      x: pt.x * (SAM_INPUT_SIZE / this.env.image.naturalWidth),
      y: pt.y * (SAM_INPUT_SIZE / this.env.image.naturalHeight)
    };
  }

  onGrab = element => evt => {
    this.grabbedElement = element;
    this.grabbedAt = this.getSVGPoint(evt);
  }

  onSelectCorner = element => evt => {}

  renderMaskToCanvas(mask, ctx, canvas, clear = true) {
    const height = mask.dims[2];
    const width = mask.dims[3];
    const data = mask.data;

    if (clear) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    const img = ctx.createImageData(width, height);

    // Rendere nur die erste Maske (Index 0)
    for (let i = 0; i < width * height; i++) {
      if (data[i] > 0.0) { // SAM 2 Logit Threshold
        const idx = i * 4;
        img.data[idx + 1] = 255; // Grün
        img.data[idx + 3] = 120; // Alpha
      }
    }

    const temp = document.createElement('canvas');
    temp.width = width;
    temp.height = height;
    temp.getContext('2d').putImageData(img, 0, 0);

    // Direkte Skalierung auf die vollen Canvas-Ausmaße
    ctx.drawImage(
      temp,
      0, 0,
      canvas.width,
      canvas.height
    );
  }

  renderPreviewMask(output) {
    console.log("output.dim", output.dim)
    const height = output.dims[2];
    const width = output.dims[3];
    const data = output.data;

    const canvas = this.previewCanvas;
    const ctx = this.previewCtx;

    if (canvas.width !== width) canvas.width = width;
    if (canvas.height !== height) canvas.height = height;
    const imageData = ctx.createImageData(width, height);
    const pixels = imageData.data;

    for (let i = 0; i < width * height; i++) {
      const idx = i * 4;
      if (data[i] > 0.0) {
        pixels[idx] = 0;
        pixels[idx + 1] = 255;
        pixels[idx + 2] = 0;
        pixels[idx + 3] = 120;
      } else {
        pixels[idx + 3] = 0;
      }
    }
    ctx.putImageData(imageData, 0, 0);
  }

  async renderPolygon(output) {

    const points = this.maskToPolygons(output);
    if (!points.length) return;
    print("polygonpoints:", points)
    const path = this.polygonsToPath(points);
    this.inner.setAttribute("d", path);
  }

  contourToPath(points) {
    if (!points || points.length === 0) return "";
    let path = `M ${points[0].x} ${points[0].y}`;
    for (let i = 1; i < points.length; i++) {
      path += ` L ${points[i].x} ${points[i].y}`;
    }
    path += " Z";
    return path;
  }

  async loadModel() {
    try {
      const basePath = this.config.assetPath;
      console.log("basePath", basePath);
      ort.env.wasm.wasmPaths = `${basePath}`;
      ort.env.wasm.simd = true;

      this.model = await ort.InferenceSession.create(
        `${basePath}model/sam2.1_hiera_large.onnx`,
        { executionProviders: ['wasm'] }
      );
      this.model = await ort.InferenceSession.create(
        `${basePath}model/sam2.1_hiera_large.onnx`,
        { executionProviders: ['wasm'] }
      );

      console.log("SAM 2 ONNX Model loaded", this.model);
      this.flushQueuedSegmentation();
    } catch (err) {
      console.error("Model load failed", err);
    }
  }

  parseNpy(buffer) {
    const view = new DataView(buffer);
    const headerLength = view.getUint16(8, true);
    const headerText = new TextDecoder().decode(
      buffer.slice(10, 10 + headerLength)
    );

    const shapeMatch = headerText.match(/\((.*?)\)/);
    if (!shapeMatch) {
      throw new Error("Shape konnte nicht gelesen werden");
    }

    const shape = shapeMatch[1]
      .split(",")
      .map(v => v.trim())
      .filter(v => v.length)
      .map(Number);

    const dataOffset = 10 + headerLength;
    const data = new Float32Array(buffer, dataOffset);

    return { data, shape };
  }

  // 🔥 Lädt die .npz ZIP-Datei herunter, entpackt sie und parst alle 3 Arrays
// 🔥 Lädt die .npz ZIP-Datei herunter, entpackt sie und parst alle 3 Arrays
  async loadEmbedding(imageId) {
    try {
      const cleanId = imageId
        .replace("kucha%2Fimages%2F", "")
        .replace("kuchatest%2Fimages%2F", "");

      // Endpoint liefert das serverseitig erzeugte {imageId}.npz Archiv
      const embeddingUrl = this.config.serverUrl + cleanId;

      const response = await fetch(embeddingUrl);
      const buffer = await response.arrayBuffer();

      // ZIP Archiv im RAM öffnen
      const zip = await JSZip.loadAsync(buffer);
      console.log("ZIP Dateien:");
      Object.keys(zip.files).forEach(f => console.log(f));

      // 🔥 HIER FEHLTE DER CODE: Die Dateien müssen erst aus dem ZIP entpackt werden!
      const bufferEmbed = await zip.file("image_embed.npy").async("arraybuffer");
      const bufferHighRes1 = await zip.file("high_res_0.npy").async("arraybuffer");
      const bufferHighRes2 = await zip.file("high_res_1.npy").async("arraybuffer");

      // Alle 3 entpackten .npy Dateien binär auslesen und die Keys passend für SAM 2.1 benennen
      this.sam2Features = {
        image_embeddings: this.parseNpy(bufferEmbed),
        high_res_features1: this.parseNpy(bufferHighRes1),
        high_res_features2: this.parseNpy(bufferHighRes2)
      };

      console.log("SAM 2.1 Embeddings erfolgreich dekomprimiert:", this.sam2Features);
      this.flushQueuedSegmentation();

    } catch (err) {
      console.error("Fehler beim Laden oder Entpacken des SAM 2 Embeddings:", err);
    }
  }

  resetState() {
    this.promptPoints = [];
    for (let h of this.handles) {
      if (h.parentNode) h.parentNode.removeChild(h);
    }
    this.handles = [];
    this.grabbedElement = null;

    this.lastResultTensor = null;
    this.currentMaskMat = null;
    this.accumulatedMaskMat = null;
    this.pendingRequest = null;
    this.lastPreviewPoint = null;

    this.previewCtx.clearRect(
      0, 0,
      this.previewCanvas.width,
      this.previewCanvas.height
    );

    this.inner.setAttribute("d", "");
    this.outer.setAttribute("d", "");
  }
async visualizeCanvasOnImage(maskCanvas, imageUrl) {

  const img = new Image();

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = imageUrl;
  });

  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;

  const ctx = canvas.getContext("2d");

  // Originalbild
  ctx.drawImage(img, 0, 0);

  // Maske darüber
  ctx.drawImage(
    maskCanvas,
    0,
    0,
    maskCanvas.width,
    maskCanvas.height,
    0,
    0,
    canvas.width,
    canvas.height
  );

  canvas.style.position = "fixed";
  canvas.style.left = "10px";
  canvas.style.top = "10px";
  canvas.style.zIndex = "999999";
  canvas.style.border = "2px solid red";
  canvas.style.maxWidth = "800px";

  document.body.appendChild(canvas);

  return canvas;
}
  close = () => {

    const combined = this.combineMasks();
    if (combined) {
  const debugCanvas = document.createElement("canvas");

  debugCanvas.width = combined.cols;
  debugCanvas.height = combined.rows;

  debugCanvas.style.position = "fixed";
  debugCanvas.style.left = "10px";
  debugCanvas.style.top = "10px";
  debugCanvas.style.zIndex = "999999";
  debugCanvas.style.border = "2px solid red";
  debugCanvas.style.background = "rgba(0,0,0,0.3)";

  document.body.appendChild(debugCanvas);

  const ctx = debugCanvas.getContext("2d");
  const img = ctx.createImageData(combined.cols, combined.rows);

  for (let i = 0; i < combined.data.length; i++) {
    if (combined.data[i] > 0) {
      const idx = i * 4;

      img.data[idx] = 0;
      img.data[idx + 1] = 255;
      img.data[idx + 2] = 0;
      img.data[idx + 3] = 255;
    }
  }

  ctx.putImageData(img, 0, 0);

      const polygons = this.matToPolygons(combined);
      const path = this.polygonsToPath(polygons);
      this.inner.setAttribute("d", path);
      combined.delete();
    }

    this.emit('close', { shape: this.group });
    console.log("passing shape to editable")
    this.resetState();
  }

  getBoundingClientRect = () => {
     return this.outer.getBoundingClientRect();
  }

dragTo = xy => {

  this.currentMousePos = xy;

  while (this.draggedElement.firstChild) {
    this.draggedElement.removeChild(this.draggedElement.lastChild);
  }

  if (!this.grabbedElement) {

    if (this.findClosePointIndex(xy) === -1) {

      this.mousepos = xy;

      const handle = this.drawHandle(xy.x, xy.y);

      if (xy.clickType === 0)
        handle.classList.add("remove");
      else
        handle.classList.add("add");

      this.draggedElement.appendChild(handle);
      this.scaleHandle(this.draggedElement.firstChild);

      this.schedulePreview(xy);
    }

  } else {
    this.onMoveCornerHandle(xy);
  }
}

  schedulePreview(point) {
    if (
      this.lastPreviewPoint &&
      this.getPointDistance(point, this.lastPreviewPoint) < this.minInferenceDistance
    ) {
      return;
    }

    this.lastPreviewPoint = { x: point.x, y: point.y };
    this.setPoints([...this.promptPoints, point], false);
  }

  getPointDistance(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  onScaleChanged = scale => {
    this.scale = scale;
    for (let handle of this.handles) {
      this.scaleHandle(handle);
    }
    if (this.draggedElement.firstChild) {
      this.scaleHandle(this.draggedElement.firstChild);
    }
  }

  findClosePointIndex = (newPoint) => {
    const threshold = 8 * this.scale;
    for (let i = 0; i < this.promptPoints.length; i++) {
      const existingPoint = this.promptPoints[i];
      const distance = Math.sqrt(
        Math.pow(existingPoint.x - newPoint.x, 2) +
        Math.pow(existingPoint.y - newPoint.y, 2)
      );
      if (distance < threshold) {
        return i;
      }
    }
    return -1;
  };

  addPoint = xy => {
    if (!this.hasStartPoint) {
      this.hasStartPoint = true;
      this.startPoint = xy;
    }
    if (this.findClosePointIndex(xy) === -1) {
      this.promptPoints.push(xy)
      this.lastPreviewPoint = { x: xy.x, y: xy.y };
      const handle = this.drawHandle(xy.x, xy.y);
      if (xy.clickType === 0){
        handle.classList.add("remove");
      } else {
        handle.classList.add("add");
      }
      handle.addEventListener('mousedown', this.onGrab(handle));
      handle.addEventListener('mouseup', this.onSelectCorner(handle));
      handle.addEventListener('contextmenu', this.onRemoveCornerHandle(handle));
      this.scaleHandle(handle);
      this.handles.push(handle)
      this.elementGroup.appendChild(handle);
      this.setPoints(this.promptPoints, true)
    } else  {
      var element = this.handles[this.findClosePointIndex(xy)]
      if (!this.grabbedElement){
        this.grabbedElement = element;
        this.grabbedAt = xy;
      } else {
        this.grabbedElement.classList.remove("select");
        this.grabbedElement = null
      }
      this.setPoints(this.promptPoints, true)
    }
  }

  undo = () => { this.pop(); }

  isClosable = () => {
    const d = this.getDistanceToStart();
    return d < 6 * this.scale;
  }

  pop = () => {
    if (!this.promptPoints.length) return;

    this.promptPoints.pop();
    const handle = this.handles.pop();

    if (handle?.parentNode) {
      handle.parentNode.removeChild(handle);
    }

    this.lastPreviewPoint = null;

    if (!this.promptPoints.length) {
      if (this.currentMaskMat) {
        this.currentMaskMat.delete();
        this.currentMaskMat = null;
      }

      this.pendingRequest = null;
      this.queuedSegmentationPoints = null;
      this.previewCtx.clearRect(
        0, 0,
        this.previewCanvas.width,
        this.previewCanvas.height
      );
      return;
    }

    this.setPoints(this.promptPoints, true);
  }

  newPart = () => { this.promptPoints.push([]); }

  get element() { return this.inner; }

  getDistanceToStart = () => {
    if (this.promptPoints.length < 1) return Infinity;

    const first = this.promptPoints[0];
    const dx = Math.abs(this.mousepos.x - first.x);
    const dy = Math.abs(this.mousepos.y - first.y);

    return Math.sqrt(dx * dx + dy * dy) / this.scale;
  }

  destroy = () => {
    if (this.overlayCanvas?.parentNode) {
      this.overlayCanvas.parentNode.removeChild(this.overlayCanvas);
    }
    window.removeEventListener('keydown', this.onKeyDown);

    if (this.elementGroup?.parentNode) {
      this.elementGroup.parentNode.removeChild(this.elementGroup);
    }

    this.multipolygon = null;
    this.elementGroup = null;
  }

  toSelection = () => {
    return new Selection({
      ...toSVGTarget(this.group, this.env.image),
      renderedVia: { name: 'segmentanything' }
    });
  }
}